import { type ClassValue, clsx } from 'clsx';
import { format } from 'date-fns';
import { twMerge } from 'tailwind-merge';

import { User } from '@/services/types/user-types';
import { isTaskPastDue, isTaskUrgent } from '@/utils/taskDateUtils';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Re-export centralized task date utilities for backward compatibility
export const taskIsPastDue = isTaskPastDue;
export const taskIsUrgent = isTaskUrgent;

const FINCH_FIRM_ID = '09ba25a6-9f6a-4db8-a8d6-252e269c620d';
const FINCH_ENGINEER_USER_IDS = new Set([
  // Dean
  'a08a2058-27bd-4125-a18d-0b20dd2db169',
  // Moyez
  '44f424a8-8e85-46dc-bc32-dcde99d3e319',
]);

export function filterStaffUsers(staffUsers: User[]) {
  return staffUsers.filter((user) => true);
}

export function formatDate(dateString: string): string {
  if (!dateString) return '';
  try {
    const date = new Date(`${dateString}T00:00:00`);
    return format(date, 'PP');
  } catch (error) {
    return dateString;
  }
}
